import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { AppContainer } from '@nutastic/nutastic-react-app';
import ComingSoonPage from './pages/ComingSoonPage';

const App = () => {
    const renderPageRoute = () => {
        return <Switch>
            <Route path={['/', '/home']} component={ComingSoonPage}/>
        </Switch>;
    };

    return <AppContainer>
        { renderPageRoute() }
    </AppContainer>;
};

export default App;
